import React, { PureComponent } from 'react';
import { withTranslation, Trans } from 'react-i18next';

import { Link } from 'formlabs-web-components/Link';
import { Select } from 'formlabs-web-components/Form';
import ContactSales from './ContactSales';
import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import classNames from 'classnames';

import Tooltip from './Tooltip';
import { wrapMultiline } from '../../utils';

import './DataSheets.module.css';

const nameFieldComp = (a, b) => (a.fields.name > b.fields.name ? 1 : -1);

class Materials extends React.Component {
  render() {
    const resins = this.props.materials;
    const resinsSorted = resins.sort(nameFieldComp);

    let renderList = resinsSorted.map((resin, i) => {
      return (
        <option
          key={`data-sheet-resin-` + resin.pk}
          name="resin"
          value={resin.pk}
        >
          {resin.fields.name}
        </option>
      );
    });

    return renderList;
  }
}

const Pdfs = ({ pdfs }) =>
  pdfs.map(pdf => {
    return (
      <li key={`pdf-` + pdf.pk}>
        <a styleName="linked-pdf" href={pdf.file}>
          <i className="fl-pdf" styleName="pdf-icon" /> {pdf.display_name}
        </a>
      </li>
    );
  });

const DataSheets = DisplayComponent(
  class App extends PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        pdfs: this.props.pdfs,
        languages: this.props.languages,
        materials: this.props.materials,
        selectedLanguage: '',
        selectedMaterial: '',
        color: this.props.color,
        open: false
      };
    }

    handleClick = () => {
      this.setState({ open: true });

      var elmList = document.getElementsByClassName('data-sheet-buttons');

      for (var i = 0; i < elmList.length; i++) {
        elmList[i].className = 'data-sheet-buttons full content';
      }

      this.setState({ selectedLanguage: '2' });

      let m = document.getElementById('pdf-materials');
      let material = parseFloat(m.options[m.selectedIndex].value);

      this.setState({ selectedMaterial: material });
    };

    render() {
      const { t, classes } = this.props;
      let pdfs = this.state.pdfs.filter(pdf => {
        return (
          pdf.resins === this.state.selectedMaterial &&
          pdf.language === this.state.selectedLanguage
        );
      });
      let technical_pdfs = pdfs.filter(pdf => pdf.sheet_type === 'technical');
      let safety_pdfs = pdfs.filter(pdf => pdf.sheet_type === 'safety');
      let updated_technical = null;
      let updated_safety = null;
      let defaultL = this.state.languages.find(
        language => language.fields.is_default === true
      );
      const pdfFilter = (pdf, type) => {
        return (
          pdf.resins === this.state.selectedMaterial &&
          pdf.language === defaultL.pk &&
          pdf.sheet_type === type
        );
      };
      if (!technical_pdfs.length) {
        try {
          technical_pdfs = this.state.pdfs.filter(pdf => {
            return pdfFilter(pdf, 'technical');
          });

          if (!technical_pdfs.length) {
            updated_technical = (
              <p>
                {t(
                  'There is no technical data sheet available for the chosen material.'
                )}
              </p>
            );
          }
        } catch (err) {}
      }

      if (!safety_pdfs.length) {
        try {
          safety_pdfs = this.state.pdfs.filter(pdf => {
            return pdfFilter(pdf, 'safety');
          });

          if (!safety_pdfs.length) {
            updated_safety = (
              <p>
                {t(
                  'There is no safety data sheet available for the chosen material.'
                )}
              </p>
            );
          }
        } catch (err) {}
      }

      const { open, color } = this.state;

      const containerclasses = classNames(color, { open: open });
      return (
        <div
          id="data-sheets"
          className={classNames(containerclasses, classes)}
          styleName={containerclasses}
        >
          <div styleName="data-sheet-options">
            <div styleName="content">
              <h3>{t('Data Sheets')}</h3>
              <p>
                {t(
                  'Download safety and technical data sheets for all Formlabs materials.'
                )}
              </p>
              <Tooltip title={t('Handling & Safety')} type="question">
                <Trans>
                  <p>
                    Resin should be handled with care. Proper handling will
                    ensure safe printing and efficient use. Our resins have been
                    designed to be similar or safer to handle as other household
                    chemicals or adhesives. Formlabs materials do not contain
                    volatile solvents so special ventilation is not required.
                    Skin contact should be avoided.
                  </p>
                  <p>
                    The Safety Data Sheets (SDS) are up to date for every resin
                    product and follow the latest government guidelines. Always
                    consult the SDS as the primary source of information to
                    understand safety and handling of Formlabs materials. For
                    more information about handling resin, learn more{' '}
                    <Link to="https://support.formlabs.com/s/article/Resin-Care?language=en_US">
                      tips for resin maintenance
                    </Link>{' '}
                    in our Help Center.
                  </p>
                </Trans>
              </Tooltip>
              <Tooltip title={t('Technical Data')} type="question">
                {wrapMultiline(t('datasheet: technical data text'))}
              </Tooltip>
            </div>
            <ul styleName={classNames('content', 'data-sheet-buttons')}>
              <li>
                <p>{t('Material')}</p>
                <span styleName="wrapper">
                  <Select
                    id="pdf-materials"
                    aria-label={t('material selector')}
                    onChange={this.handleClick}
                  >
                    <option>– {t('Select')} –</option>
                    <Materials materials={this.state.materials} />
                  </Select>
                </span>
              </li>
            </ul>
            <div id="pdfs" styleName="pdfs">
              <div styleName="content results">
                <div styleName="results-left">
                  <h3>{t('Technical Data Sheets')}</h3>
                  {updated_technical}
                </div>
                <ul>
                  <Pdfs pdfs={technical_pdfs} />
                </ul>
              </div>
              <hr />
              <div styleName="content results">
                <div styleName="results-left">
                  <h3>{t('Safety Data Sheets')}</h3>
                  {updated_safety}
                </div>
                <ul>
                  <Pdfs pdfs={safety_pdfs} />
                </ul>
              </div>
              <hr />
              <div styleName={classNames('content', 'request')}>
                {t('Need a Data Sheet for another country?')}
                <br />
                <ContactSales
                  linkText={t('Click Here to Request')}
                  displayType="button"
                  buttonColor="light"
                  datasheets={true}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);

DataSheets.propTypes = {};

export default withTranslation()(DataSheets);
